import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import { footerColumns, LOGO_URL } from '../data/navigation';
export function Footer() {
  return <footer className="bg-midnight-navy pt-20 pb-10" data-id="element-91" data-mp="32oniuyfytg6u">
      <div className="max-w-7xl mx-auto px-6" data-id="element-92" data-mp="32lrnnhvi55m3">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16" data-id="element-93" data-mp="36oo5359b2vog">
          <div className="lg:col-span-5 space-y-6" data-id="element-94" data-mp="3ufa4y995p9nd">
            <Link to="/" className="inline-block" data-id="element-95" data-mp="3ufjuxwu7bgt2">
              <img src={LOGO_URL} alt="ROI Complete" className="h-20 md:h-24 w-auto object-contain" data-id="element-96" data-mp="38h81hlebwon" />
            </Link>
            <p className="text-stark-white/50 text-base leading-relaxed max-w-sm" data-id="element-97" data-mp="3qdf5796vj4bp">
              A business performance platform combining executive expertise,
              operational strategy, and technology to help organizations
              increase profitability and scale with confidence.
            </p>
            <div className="space-y-3 text-base" data-id="element-98" data-mp="3l9abhd1s8u1s">
              <a href="tel:+15551234567" className="flex items-center gap-3 text-stark-white/60 hover:text-stark-white transition-colors" data-id="element-99" data-mp="3la27gozaktsl">
                <PhoneIcon className="w-4 h-4 text-royal-blue" data-id="element-100" data-mp="3v8hpm2gccspy" />
                +1 (555) 123-4567
              </a>
              <a href="mailto:hello@roicomplete.com" className="flex items-center gap-3 text-stark-white/60 hover:text-stark-white transition-colors" data-id="element-101" data-mp="3q7buxz34evds">
                <MailIcon className="w-4 h-4 text-royal-blue" data-id="element-102" data-mp="33nm44yp1hk6" />
                hello@roicomplete.com
              </a>
              <div className="flex items-center gap-3 text-stark-white/60" data-id="element-103" data-mp="huo6978syzw5">
                <MapPinIcon className="w-4 h-4 text-royal-blue" data-id="element-104" data-mp="cuiku8t4m9mi" />
                1200 Market Street, Suite 400, Atlanta, GA
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-10" data-id="element-105" data-mp="msy4jqptqglz">
            {footerColumns.map(column => <div key={column.title} className="space-y-5" data-id="element-106" data-mp="twxqz8ok588s">
                <h3 className="text-stark-white text-sm font-bold uppercase tracking-widest" data-id="element-107" data-mp="yv953vlvy4wt">
                  {column.title}
                </h3>
                <ul className="space-y-3" data-id="element-108" data-mp="13rfzqs8tztzg">
                  {column.links.map(link => <li key={link.name} data-id="element-109" data-mp="18m3s526yh8jb">
                      <Link to={link.href} className="text-stark-white/50 hover:text-stark-white text-base transition-colors" data-id="element-110" data-mp="1cm484r9pdrsh">
                        {link.name}
                      </Link>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-stark-white/40 text-base" data-id="element-111" data-mp="3obexrtubnece">
          <span data-id="element-112" data-mp="3tarq2u3ypdmd">© 2026 ROI Complete. All rights reserved.</span>
          <div className="flex gap-6" data-id="element-113" data-mp="2afdirds2japb">
            <Link to="/resources" className="hover:text-stark-white transition-colors" data-id="element-114" data-mp="2agewjq0gybaq">
              Privacy Policy
            </Link>
            <Link to="/resources" className="hover:text-stark-white transition-colors" data-id="element-115" data-mp="21mk1jat2a18t">
              Terms &amp; Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}